(function () {
  function actualizarContador(itemCount) {
    if (typeof itemCount === 'undefined') return;
    document.querySelectorAll('#CartDrawer-ItemCount, .mc-carrito__contador').forEach(function (el) {
      var palabra = itemCount === 1 ? el.dataset.uno : el.dataset.otros;
      el.textContent = '· ' + itemCount + ' ' + (palabra || '');
    });
  }

  function refrescarSeccion(sectionId, selector, aplicar) {
    return fetch(routes.cart_url + '?section_id=' + sectionId)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector(selector);
        if (source) aplicar(source);
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  function refrescarCarrito() {
    var tareas = [];
    var cartIcon = document.getElementById('cart-icon-bubble');
    var drawerItems = document.querySelector('cart-drawer-items');
    var mainItems = document.getElementById('main-cart-items');
    var mainFooter = document.getElementById('main-cart-footer');

    if (cartIcon) {
      tareas.push(
        refrescarSeccion('cart-icon-bubble', '.shopify-section', function (source) {
          cartIcon.innerHTML = source.innerHTML;
        })
      );
    }

    if (drawerItems) {
      tareas.push(
        refrescarSeccion('cart-drawer', 'cart-drawer-items', function (source) {
          drawerItems.replaceWith(source);
        })
      );
      tareas.push(
        refrescarSeccion('cart-drawer', '.cart-drawer__footer', function (source) {
          var target = document.querySelector('.cart-drawer__footer');
          if (target) target.replaceWith(source);
        })
      );
    }

    if (mainItems) {
      tareas.push(
        refrescarSeccion(mainItems.dataset.id, 'cart-items', function (source) {
          var target = document.querySelector('cart-items');
          if (target) target.innerHTML = source.innerHTML;
        })
      );
    }

    if (mainFooter) {
      tareas.push(
        refrescarSeccion(mainFooter.dataset.id, '.js-contents', function (source) {
          var target = mainFooter.querySelector('.js-contents');
          if (target) target.innerHTML = source.innerHTML;
        })
      );
    }

    return Promise.all(tareas);
  }

  if (!customElements.get('mc-cart-upsells')) {
    customElements.define(
      'mc-cart-upsells',
      class extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('change', this.onChange.bind(this));
        }

        onChange(event) {
          var checkbox = event.target.closest('input[type="checkbox"]');
          if (!checkbox) return;
          var variantId = checkbox.dataset.variantId;
          checkbox.disabled = true;

          var request;
          if (checkbox.checked) {
            request = fetch(
              routes.cart_add_url,
              Object.assign({}, fetchConfig(), {
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
              })
            );
          } else {
            request = fetch(
              routes.cart_change_url,
              Object.assign({}, fetchConfig(), {
                body: JSON.stringify({ id: variantId, quantity: 0 }),
              })
            );
          }

          request
            .then(function (response) {
              return response.json();
            })
            .then(function () {
              return fetch(routes.cart_url + '.json').then(function (r) {
                return r.json();
              });
            })
            .then(function (cart) {
              actualizarContador(cart.item_count);
              return refrescarCarrito();
            })
            .catch(function (e) {
              console.error(e);
              checkbox.checked = !checkbox.checked;
            })
            .finally(function () {
              checkbox.disabled = false;
            });
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.item_count !== 'undefined') {
          actualizarContador(event.cartData.item_count);
        }
      });
    }
  });
})();

/* Cuenta atrás del aviso "Carrito reservado durante": 5 min desde que hay productos; al acabar vuelve a "Envío gratis" (no se reinicia sola) */
(function () {
  var CLAVE = 'mc_reserva_fin';
  var DURACION = 5 * 60 * 1000;

  function leer() {
    try { return parseInt(localStorage.getItem(CLAVE), 10) || 0; } catch (e) { return 0; }
  }
  function guardar(v) {
    try { if (v) localStorage.setItem(CLAVE, String(v)); else localStorage.removeItem(CLAVE); } catch (e) {}
  }

  function tick() {
    var avisos = document.querySelectorAll('[data-mc-reserva]');
    if (!avisos.length) {
      guardar(0);
      return;
    }
    var fin = leer();
    if (!fin) {
      fin = Date.now() + DURACION;
      guardar(fin);
    }
    var resto = fin - Date.now();
    avisos.forEach(function (el) {
      if (resto > 0) {
        var s = Math.ceil(resto / 1000);
        var t = ('0' + Math.floor(s / 60)).slice(-2) + ':' + ('0' + (s % 60)).slice(-2);
        el.textContent = el.dataset.textoReserva + ' ' + t;
      } else {
        el.textContent = el.dataset.textoEnvio;
      }
    });
  }

  tick();
  setInterval(tick, 1000);
})();

/* Añadir al carrito desde la página de producto: se añade sin salir de la página y se abre el carrito lateral */
(function () {
  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form || !form.matches || !form.matches('[data-mc-producto]')) return;
    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof routes === 'undefined' || typeof fetchConfig !== 'function') return; // sin carrito lateral: comportamiento normal
    evento.preventDefault();

    var formId = form.getAttribute('id');
    var botones = document.querySelectorAll('[name="add"][form="' + formId + '"], #' + formId + ' [name="add"]');
    if (botones.length && botones[0].getAttribute('aria-disabled') === 'true') return;
    botones.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.classList.add('loading'); });

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var datos = new FormData(form);
    datos.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
    datos.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
    config.body = datos;

    fetch(routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (respuesta) {
        if (respuesta.status) {
          window.alert(respuesta.description || respuesta.message || 'No se ha podido añadir al carrito');
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: datos.get('id'), cartData: respuesta });
        }
        cart.renderContents(respuesta);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function (e) {
        console.error(e);
        form.submit(); // si algo falla, vuelve al método clásico
      })
      .finally(function () {
        botones.forEach(function (b) { b.removeAttribute('aria-disabled'); b.classList.remove('loading'); });
      });
  });
})();

/* Móvil: al abrir el carrito el fondo no se mueve (también en iPhone) */
(function () {
  var movil = window.matchMedia('(max-width: 749px)');
  var bloqueado = false;
  var scrollGuardado = 0;

  function bloquear() {
    if (bloqueado || !movil.matches) return;
    scrollGuardado = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollGuardado + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    bloqueado = true;
  }
  function liberar() {
    if (!bloqueado) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollGuardado);
    bloqueado = false;
  }
  function revisar() {
    var cart = document.querySelector('cart-drawer');
    if (!cart) return;
    if (cart.classList.contains('active')) bloquear(); else liberar();
  }
  function iniciar() {
    var cart = document.querySelector('cart-drawer');
    if (!cart) return;
    new MutationObserver(revisar).observe(cart, { attributes: true, attributeFilter: ['class'] });
    revisar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
